// extracted by mini-css-extract-plugin
module.exports = {"error":"DeleteConversationConfirm_error__NNEiG"};